import { TransactionTime } from "@ctypes";
import { useTransactions } from "./useTransactions";

export const usePendingTransactions = () => {
  return useTransactions({
    time: TransactionTime.Pending,
  });
};
